import { useField } from "formik";

const FormikState = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className="field-container">
		<div className="error-container"><em>*</em>{meta.touched && meta.error && <div className="error">{meta.error}</div>}</div>
      <select
        {...field}
        {...props}
      >
        	<option value="United States">United States</option>
					<option value="Canada">Canada</option>
      </select>
    </div>
  );
};
export default FormikState;